import { GenderEnum } from '../../lib/types/enums/common/gender.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type CheckSsnValidityInput = {
  ssn: string
  birthPlace: string
  birthDate: string
  gender: GenderEnum
  birthDepartment?: string
}

export function checkSsnDataValidity(input: CheckSsnValidityInput) {
  return restApiClient
    .url(constructApiUrl(API.candidate.checkSsnDataValidity.url, null))
    .post<{ valid: boolean }>(input)
}
